export default __webpack_public_path__ + "static/media/(54).1184ae8b.jpg";